$(function() {
  clickMenuProductList();
  clickOverCategory();
  slideRange();
  clickCategoryMobile();
});

// Click menu product list
function clickMenuProductList() {
  $(".sidebar-main-left__menu-wrap-lv1-item-dropdown").click(function() {

    var subMenu = $(this).siblings(".sidebar-main-left__menu-wrap-lv2");
    if (subMenu.length > 0) {
      subMenu.slideToggle(300);
      $(".sidebar-main-left__menu-wrap-lv2").not(subMenu).slideUp(300);
      return false;
    }
  });

  $(".sidebar-main-left__menu-wrap-lv1-item > a").click(function() {
    $(".sidebar-main-left__menu-wrap-lv1-item a").removeClass("active");
    $(this).addClass("active");
  });

  $(".sidebar-main-left__menu-wrap-lv2-item a").click(function() {
    $(".sidebar-main-left__menu-wrap-lv1-item a").removeClass("active");
    $(this).addClass("active");
  });
}

function searchBrand(id) {
  var input = document.getElementById(id);
  var key = input.value.toLowerCase();
  $(input).parent().parent().find(".brand-list__item").each(function (index) {
    item = $(this)
    if($(this).find("label").html().toLowerCase().includes(key)){
      item.removeClass("hide");
    }
    else{
      item.addClass("hide");
    }
  });
}

// Filter price
function slideRange() {

  const rangeInput = document.querySelectorAll(".range-input input"),
  priceInput = document.querySelectorAll(".price-input input"),
  range = document.querySelector(".slider .progress");
  let priceGap = 100;

  priceInput.forEach(input =>{
      input.addEventListener("input", e =>{
          let minPrice = parseInt(priceInput[0].value),
          maxPrice = parseInt(priceInput[1].value);
          
          if((maxPrice - minPrice >= priceGap) && maxPrice <= rangeInput[1].max){
              if(e.target.className === "input-min"){
                  rangeInput[0].value = minPrice;
                  range.style.left = ((minPrice / rangeInput[0].max) * 100) + "%";
              }else{
                  rangeInput[1].value = maxPrice;
                  range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
              }
          }
      });
  });
  rangeInput.forEach(input =>{
      input.addEventListener("input", e =>{
          let minVal = parseInt(rangeInput[0].value),
          maxVal = parseInt(rangeInput[1].value);
          if((maxVal - minVal) < priceGap){
              if(e.target.className === "range-min"){
                  rangeInput[0].value = maxVal - priceGap
              }else{
                  rangeInput[1].value = minVal + priceGap;
              }
          }else{
              priceInput[0].value = minVal;
              priceInput[1].value = maxVal;
              range.style.left = ((minVal / rangeInput[0].max) * 100) + "%";
              range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
          }
      });
  });
}

// background over
function clickOverCategory() {
  $(document).on('click', "#over, .sidebar-main-left-mobile-close", function() {
    if ($(window).width() < 768) {
      if ($(".sidebar-main-left").hasClass("active")) {
        $('#over').fadeOut(200, function() {
          $('#over').remove();
          $('body').css("overflow", "");
        });
        $(".sidebar-main-left").removeClass("active");
        return false;
      }
    }
  });
}

function clickCategoryMobile() {
  if ($(window).width() < 769) {
    $(".list-product-main__header-filter-button").mouseup(function(e) {

      $(".sidebar-main-left").addClass("active");
      $('header').append('<div id="over">');
      $('#over').fadeIn(200);
      $('body').css("overflow", "hidden");

    });
  }
}